module.exports = __webpack_public_path__ + "img/m_foot.86896514.png";